export default "__VITE_ASSET__DKsDkP6P__"